const MAX_WEIGHT_POUNDS = 500;
const MIN_WEIGHT_POUNDS = 40;

// From https://stackoverflow.com/a/46181
export function validateEmail(email) {
  // eslint-disable-next-line max-len
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export const isReasonablePlayerWeight = weightInPounds => {
  return weightInPounds != null
    && weightInPounds !== ''
    && !isNaN(weightInPounds)
    && weightInPounds > MIN_WEIGHT_POUNDS
    && weightInPounds < MAX_WEIGHT_POUNDS;
};
